export { Tag, DecorativeTag } from './Tag.styles'
export type { TagColor, TagSizeType } from './Tag.types'
